import { toast } from 'sonner';

import { useEffect } from 'react';

import { useNamespace, useTranslation } from '@splitfiesta/i18n';

import { usePWAUpdate } from '@/hooks/usePWAUpdate';

/**
 * Component that shows a toast notification when a new app version is available
 * Clicking the toast will refresh the page with the new version
 */
export function PWAUpdatePrompt() {
  const { t } = useTranslation();
  useNamespace('app');
  const { needRefresh, update, dismiss } = usePWAUpdate();

  useEffect(() => {
    if (needRefresh) {
      toast.info(t('app:pwa.updateAvailable'), {
        description: t('app:pwa.updateDescription'),
        duration: Infinity, // Don't auto-dismiss
        action: {
          label: t('app:pwa.updateNow'),
          onClick: () => {
            update();
          },
        },
        onDismiss: () => {
          dismiss();
        },
      });
    }
  }, [needRefresh, update, dismiss, t]);

  return null;
}
